/**
 * This utility calculates how many Satoshis a TX signer is going to spend when the TX gets confirmed.
 * Note: the actual sending value may be changed even after TX is signed, which depends on the SIGHASH value(s).
 **/
import { calculateInputs, calculateOutputs } from './common.js';
export function estimateTransfer({ addresses, currency, fee, inputIndexesToSign, psbt, simulationResult, }) {
    const inputAmount = currency.baseUnit(calculateInputs({ psbt, inputIndexesToSign }).toString());
    const outputAmountSelfSend = currency.baseUnit(calculateOutputs({ psbt, addresses }).toString());
    const outputAmountSelfSendWithFee = outputAmountSelfSend.add(fee);
    if (inputAmount.gte(outputAmountSelfSendWithFee)) {
        simulationResult.balanceChanges.willSend.push({
            balance: inputAmount.sub(outputAmountSelfSendWithFee),
        });
    }
    else {
        simulationResult.balanceChanges.willReceive.push({
            balance: outputAmountSelfSendWithFee.sub(inputAmount),
        });
    }
}
